export default "__VITE_ASSET__9ffc7d77__"